import { call, put, takeLeading } from 'redux-saga/effects';
import { FETCH_USER_MENU, SET_USER_MENU } from 'store/key';
import { produce } from 'utility/general';
import api from 'api/call';
import { safeSaga } from 'store';
import { orderBy } from 'lodash';

const initialState = { data: [], isLoading: false, isError: false };

function* getUserMenu(action) {
    const { callback = () => {} } = action.payload;

    try {
        yield put({ type: SET_USER_MENU, payload: { isLoading: true, isError: false } });
        const response = yield call(api.menu.getUserMenu);

        const { result } = response.data;

        const sortedResult = orderBy(result, 'menuOrder', 'asc');

        const formattedData = [];

        sortedResult.forEach((item) => {
            if (item.parentId === null) {
                item.subRoute = [];
                formattedData.push(item);
            } else {
                formattedData.find((formattedItem) => formattedItem.id === item.parentId)?.subRoute?.push(item);
            }
        });

        yield put({ type: SET_USER_MENU, payload: { data: formattedData, isLoading: false } });
    } catch (error) {
        yield put({ type: SET_USER_MENU, payload: { isError: true, isLoading: false } });
    }

    callback();
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_MENU:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchMenu() {
    yield takeLeading(FETCH_USER_MENU, safeSaga(getUserMenu));
}

export default reducer;
